import React, { FC, useContext } from 'react'
import SuccessIcon from '@mui/icons-material/CheckCircle'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'

import ManageContext from '../../contexts/manage'

import {
  IRecord_Booking_Core_Viewable,
} from '@kaidam/fc-shared/src/types/schema/booking'

const ManageTabs: FC<React.PropsWithChildren<{
  data?: IRecord_Booking_Core_Viewable,
}>> = ({
  data,
}) => {
  const manage = useContext(ManageContext)

  const tabStyles = {
    width: '100%',
    minWidth: '100%',
    alignItems: 'flex-start',
  }

  const titleContainerStyles = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    '& .text': {
      flexGrow: 1,
      width: '100%',
      textAlign: 'left',
    },
    '& .icon': {
      flexGrow: 0,
      ml: 1,
    },
  }

  return (
    <Tabs
      value={manage.pageIndex}
      orientation="vertical"
      onChange={(e, index) => manage.openPage(index)}
      indicatorColor="primary"
      textColor="primary"
      variant="fullWidth"
      aria-label="booking process tabs"
    >
      <Tab sx={tabStyles} label="Booking" />
      <Tab sx={tabStyles} label="Payment" />
      <Tab sx={tabStyles} label="Details" />
      <Tab
        sx={tabStyles}
        label={
          <Box sx={titleContainerStyles}>
            <div className="text">
              Pre-Survey
            </div>
            <div className="icon">
              {data?.submitted_at_presurvey ? <SuccessIcon /> : null}
            </div>
          </Box>
        }
      />
      <Tab
        sx={tabStyles}
        label={
          <Box sx={titleContainerStyles}>
            <div className="text">
              Post-Survey
            </div>
            <div className="icon">
              {data?.submitted_at_postsurvey ? <SuccessIcon /> : null}
            </div>
          </Box>
        }
      />
      <Tab
        sx={tabStyles}
        label={
          <Box sx={titleContainerStyles}>
            <div className="text">
              1 Month Feedback
            </div>
            <div className="icon">
              {data?.submitted_at_monthfeedback ? <SuccessIcon /> : null}
            </div>
          </Box>
        }
      />
      <Tab
        sx={tabStyles}
        label={
          <Box sx={titleContainerStyles}>
            <div className="text">
              1 Year Feedback
            </div>
            <div className="icon">
              {data?.submitted_at_yearfeedback ? <SuccessIcon /> : null}
            </div>
          </Box>
        }
      />
    </Tabs>
  )
}

export default ManageTabs